module.exports = __webpack_public_path__ + "landing_slider_third_slide_376x627.a669462.jpg";